{
  "lead": "Mga post, serbisyo, opisina, gabay, turismo, dokumento at iba pa, sa iisang lugar.",
  "label": "Maghanap sa app",
  "placeholder": "Ano ang hinahanap mo?",
  "hint": "Mag-type ng hindi bababa sa dalawang titik.",
  "noResults": "Walang nahanap para sa \"{q}\"",
  "noResultsHint": "Subukan ang mas maikling salita, o tingnan ang baybay.",
  "resultCount": "{count} resulta",
  "type_post": "Mga post at kaganapan",
  "type_service": "Mga serbisyo",
  "type_office": "Mga opisina at barangay",
  "type_guide": "Mga gabay sa bayan",
  "type_market": "Presyo sa palengke",
  "type_facility": "Mga pasilidad",
  "type_proposal": "Mga panukala",
  "type_lost_found": "Nawala at natagpuan",
  "type_tourist_spot": "Mga pasyalan",
  "type_trail": "Mga trail",
  "type_document": "Mga dokumento",
  "type_bid": "Bidding at award",
  "type_ordinance": "Mga ordinansa at resolusyon",
  "type_official": "Mga opisyal"
}
